import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';
import SearchIcon from '@mui/icons-material/Search';
import { 
  Select, 
  MenuItem, 
  FormControl, 
  InputLabel, 
  Button,
  Chip,
  Box as MuiBox,
  Tooltip, 
  Grid
} from '@mui/material';
// With these individual imports
import ReplayIcon from '@mui/icons-material/Replay';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SplitscreenIcon from '@mui/icons-material/Splitscreen';

import styled from 'styled-components';
import Swal from 'sweetalert2';
//import languages from '../libs/languages';
import { file2vtt, getSubNodesfromVtt, sub2srt, sub2vtt } from '../libs/readSub/SubUtils';
import { download, getExt } from '../utils';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CloseIcon from '@mui/icons-material/Close';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import platform from 'platform';
import Logo from '../assets/SRMD-Logo.png';
import ModernBreadcrumbs from '../components/navigation/ModernBreadcrumbs';
import { fetchVTTFile } from '../components/subtitles/ReadSubtitleString';
import { getLanguagesForEditView } from '../components/subtitles/SelectLanguageComponent';
import { useLogging } from '../folders/LoggingProvider';
import videoCRUDServiceInstance from '../services/VideoCRUDService';
import sectionManagementService from '../services/SectionManagementService';
import {useAutoSave} from '../hooks/useAutoSave'
import SaveIcon from '@mui/icons-material/Save';
import CircularProgress from '@mui/material/CircularProgress';
// Add this with other imports
import BugReportIcon from '@mui/icons-material/BugReport';
import {formatUserName} from '../utils/formatUtils';

const Style = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    width: 100%; // Make sure Style takes full width
    max-width: 100%; // Prevent overflow

    .tool{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding: 3px 3px;
        max-width: 100%;
        width: 100%;
        flex:1;
    }

    .top {
        display: flex; // Fix this property - was display: flex-direction
        flex-direction: column; // Changed from row to column
        width: 100%; // Ensure it takes full width
        flex: 1; // Add flex: 1 to fill container
    }

    /* First operate div for the logo and breadcrumbs */
    .operate:first-child {
        display: flex;
        
        .breadcrumb {
            flex: 1;
            width: 100%;
        }
    }

    /* Second operate div for the toolbar controls */
    .operate:nth-child(2) {
        display: flex;
        flex-direction: row;
        justify-content: flex-end; // Ensure everything aligns to the right
        align-items: center;
        flex-wrap: nowrap;
        overflow-x: auto;
        
        .breadcrumb {
            display: none;
        }
        
        button, .MuiFormControl-root {
            flex-shrink: 0;
        }
        
        .left-buttons {
            display: none;
        }
        
        .right-buttons {
            display: flex;
            align-items: center;
            justify-content: flex-end; // This is correct
            margin-left: auto; // Change from 40% to auto to push to the right
            padding-right: 10px; // Add some padding on the right
            gap: 8px; // Use gap instead of individual margins for consistent spacing
            flex-wrap: nowrap; // Prevent wrapping
            overflow-x: auto; // Allow horizontal scrolling if needed
        }

        /* Adjust button margins in right-buttons */
        .right-buttons .MuiButton-root,
        .right-buttons .MuiFormControl-root {
            margin-left: 0 !important; // Remove individual left margins
        }
    }
;

/* Search box styling */
.searchboxs {
    background: rgba(30, 30, 30, 0.95);
    border-radius: 0 0 6px 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    position: fixed;
    top: -100px; /* Start off-screen */
    left: 0;
    right: 0;
    width: 100%;
    padding: 16px 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    transition: top 0.3s ease;
    display: flex;
    align-items: center;
    
    &.open {
        top: 0; /* Slide in from the top */
        display: flex;
    }
    
    .navsearch {
        background: rgba(51, 51, 51, 0.7);
        border: none;
        border-right: 1px solid rgba(68, 68, 68, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0 3px;
        color: #ccc;
        transition: color 0.2s ease;
        
        &:hover {
            color: #fff;
        }
        
        &.open svg {
            transform: rotate(90deg);
            transition: transform 0.2s ease;
        }
    }
    
    .searchboxlist {
        padding: 1px;
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
        
        ul {
            list-style: none;
            padding: 0;
            margin: 0 0 5px 0;
            display: flex;
            align-items: center;
            
            li {
                margin-right: 5px;
                
                &.search-input {
                    flex: 1;
                    
                    input {
                        width: 100%;
                        padding: 8px 12px;
                        border: 1px solid rgba(68, 68, 68, 0.7);
                        border-radius: 4px;
                        background: rgba(51, 51, 51, 0.7);
                        color: #fff;
                        font-size: 14px;
                        
                        &:focus {
                            outline: none;
                            border-color: rgba(0, 123, 255, 0.5);
                            box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
                        }
                    }
                }
                
                span {
                    color: #aaa;
                    font-size: 0.8rem;
                    margin: 0 8px;
                    white-space: nowrap;
                }
                
                .updown-navs {
                    background: rgba(68, 68, 68, 0.7);
                    border: 1px solid rgba(85, 85, 85, 0.5);
                    border-radius: 4px;
                    padding: 4px;
                    cursor: pointer;
                    margin: 0 2px;
                    color: #ccc;
                    transition: all 0.2s ease;
                    
                    &:hover:not(:disabled) {
                        background: rgba(85, 85, 85, 0.7);
                        color: #fff;
                    }
                    
                    &:disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                }
                
                .colsesearch {
                    background: rgba(68, 68, 68, 0.7);
                    border: 1px solid rgba(85, 85, 85, 0.5);
                    border-radius: 4px;
                    padding: 4px;
                    cursor: pointer;
                    color: #ccc;
                    transition: all 0.2s ease;
                    
                    &:hover {
                        background: rgba(85, 85, 85, 0.7);
                        color: #fff;
                    }
                }
                
                .buttons {
                    display: flex;
                    
                    button {
                        background: #007ACC !important;
                        color: white !important;
                        border: none !important;
                        border-radius: 4px;
                        padding: 6px 12px;
                        margin-right: 5px;
                        cursor: pointer;
                        font-size: 13px;
                        transition: background 0.2s ease;
                        
                        &:hover {
                            background: #0062A3 !important;
                        }
                    }
                }
            }
        }
    }
}

/* Add this to your Style component's CSS definition, after the existing breadcrumb class */

.breadcrumb {
    flex: 1;
    width: 100%;
    
    /* Make breadcrumbs responsive */
    @media (max-width: 768px) {
        .header-container {
            flex-direction: column !important;
            
            /* Make logo smaller on small screens */
            .MuiAvatar-root {
                width: 32px !important;
                height: 32px !important;
                margin-right: 8px !important;
                align-self: flex-start;
            }
            
            /* Stack header elements vertically on small screens */
            .right-section {
                width: 100%;
                
                .top-row {
                    flex-wrap: wrap;
                    margin-bottom: 4px !important;
                    
                    /* Hide the tagline on very small screens */
                    .header-tagline {
                        display: none;
                    }
                }
                
                /* Make breadcrumbs scrollable horizontally */
                .breadcrumb-row {
                    .MuiBreadcrumbs-ol {
                        display: flex;
                        flex-wrap: nowrap !important;
                        overflow-x: auto;
                        padding-bottom: 4px;
                        scrollbar-width: thin;
                        
                        &::-webkit-scrollbar {
                            height: 3px;
                        }
                        
                        &::-webkit-scrollbar-track {
                            background: rgba(255, 255, 255, 0.05);
                        }
                        
                        &::-webkit-scrollbar-thumb {
                            background-color: rgba(255, 255, 255, 0.2);
                            border-radius: 3px;
                        }
                        
                        .MuiBreadcrumbs-li {
                            white-space: nowrap;
                            flex-shrink: 0;
                        }
                    }
                }
            }
        }
    }
    
    /* Even more compact for very small screens */
    @media (max-width: 480px) {
        .header-container {
            .right-section {
                .top-row {
                    /* Hide tagline completely */
                    .header-tagline {
                        display: none;
                    }
                    
                    /* Make user email smaller */
                    .user-info {
                        font-size: 0.7rem !important;
                    }
                    
                    /* Make language badge smaller */
                    .language-badge {
                        font-size: 0.65rem !important;
                        padding: 0 4px !important;
                    }
                }
            }
        }
    }
}
`;

export default function Header({
    undoSubs,
    clearSubs,
    setLoading,
    subtitle,
    formatSub,
    setSubtitle,
    notify,
    translate,
    setTranslate,
    viewEng,
    setViewEng,
    bookmarked,
    subtitleComment,
    selectedLng,
    setSelectedLng,

    // Search related props
    showSearch,
    setShowSearch,
    handleShowSearch,
    searchTerm: parentSearchTerm,
    replaceTerm: parentReplaceTerm,
    onSearchTermChange,
    onReplaceTermChange,
    matchOffsets,
    currentMatchIndex,
    goToNextMatch,
    goToPreviousMatch,
    handleReplace,
    handleReplaceAll,
    
    lngIndex,
    setLngIndex,
    setLanguageSubTitle,
    setBookmarked,
    setSubtitleComment,
    readOnly,
    duplicateSessionDetected,
}) {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [breadcrumb, setBreadcrumb] = useState([]);
    const { addLog, clearLogs } = useLogging();
    let cumulativePath = '/videos';
    const { logs, copyLogsToClipboard } = useLogging();

    const open = Boolean(anchorEl);

    const [exportValue, setExportValue] = useState('SRT');
    const [languages, setLanguages] = useState([]);

    // Add this line to create the currentPath from breadcrumb
    const currentPath = breadcrumb && breadcrumb.length > 0 ? `/${breadcrumb.join('/')}` : '/';

    const user = JSON.parse(localStorage.getItem('authUser'));

    const [sections, setSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState(null);
    const [loadingSections, setLoadingSections] = useState(false);
    const [sectionError, setSectionError] = useState(null);

    // Define local state for search
    const [showReplace, setShowReplace] = useState(false);
    const [searchTerm, setSearchTerm] = useState(parentSearchTerm || '');
    const [replaceTerm, setReplaceTerm] = useState(parentReplaceTerm || '');
    const [inputText1, setInputText1] = useState('');
    const [inputText2, setInputText2] = useState('');
    const [lnagText1, setLnagText1] = useState('');
    const [lnagText2, setLnagText2] = useState('');
    // Add these state variables inside your Header component
    const [containerWidth, setContainerWidth] = useState(window.innerWidth);
    const headerContainerRef = useRef(null);

    // Add this useEffect to track the header container width
    useEffect(() => {
    if (!headerContainerRef.current) return;
    
    const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
        setContainerWidth(entry.contentRect.width);
        }
    });
    
    resizeObserver.observe(headerContainerRef.current);
    
    return () => {
        resizeObserver.disconnect();
    };
    }, []);

    // Create a separate autoSave function first
    const autoSaveFunction = async (importSource = null) => {
        // Get subtitles from localStorage or use the passed subtitle
        const currentSubtitles = window.localStorage.getItem('subtitle')
            ? JSON.parse(window.localStorage.getItem('subtitle'))
            : subtitle;
        
        // Don't attempt to save if no subtitles exist
        if (!currentSubtitles || currentSubtitles.length === 0) 
            return { success: false, message: "No subtitles to save" };
        
        if (readOnly) {
            let message;
            if (duplicateSessionDetected) {
                message = 'Duplicate session detected. Please refresh the page.';
            } else {
                message = 'Read-Only Mode. You cannot save changes.';
            }
            
            console.log(message);
            addLog(message);
            return { success: false, message };
        }
        
        // If we're editing a section, save to the section
        if (selectedSection) {
            try {
                const videoProps = JSON.parse(localStorage.getItem('videoProps'));
                
                // Generate VTT content from subtitles
                let vttContent = "WEBVTT\n\n";
                
                for (const sub of currentSubtitles) {
                    if (sub.start === '00:00:00' && sub.end === '00:00:00') continue;
                    
                    vttContent += `${sub.start} --> ${sub.end}\n`;
                    vttContent += `${sub.text2}\n\n`;
                }
                
                // Save to the section
                await sectionManagementService.saveSection(
                    videoProps.id,
                    selectedLng,
                    selectedSection.id,
                    vttContent
                );
                
                if (!importSource) {
                    addLog(`Saved changes to section: ${selectedSection.name}`);
                }
                
                return { success: true };
            } catch (err) {
                console.error('Error saving section:', err);
                addLog(`Failed to save section: ${err.message}`);
                return { success: false, error: err, message: err.message };
            }
        }
        
        // Otherwise, save the full subtitle
        try {
            const videoProps = JSON.parse(localStorage.getItem('videoProps'));
            
            // Filter subtitles where start, end, text are not all empty
            const filteredSubtitle = currentSubtitles.filter((transcript) => {
                return (
                    transcript.start !== '00:00:00' ||
                    transcript.end !== '00:00:00' ||
                    transcript.text !== '' ||
                    transcript.text2 !== ''
                );
            });
            
            const saveResult = await videoCRUDServiceInstance.saveSubtitleContent(
                filteredSubtitle, 
                selectedLng, 
                bookmarked, 
                subtitleComment,
                addLog,
                importSource ? false : true // Only show feedback if not importing
            );
            
            return { success: true };
        } catch (err) {
            console.error('Error saving full subtitle:', err);
            addLog(`Failed to save subtitle: ${err.message}`);
            return { success: false, error: err, message: err.message };
        }
    };
    
    // Set onAutoSave to use our autoSaveFunction
    const onAutoSave = useCallback(autoSaveFunction, [
        subtitle, 
        selectedSection, 
        readOnly, 
        duplicateSessionDetected, 
        selectedLng,
        bookmarked,
        subtitleComment
    ]);

    const { lastSaveTime, isSaving, lastError, saveNow } = useAutoSave({
        saveFunction: autoSaveFunction,
        data: subtitle,
        enabled: user?.languageAccess?.[selectedLng] === 'WRITE' || user?.languageAccess?.[selectedLng] === 'ADMIN',
        interval: 30000, // 30 seconds
        inactivityDelay: 600000, // 10 minutes
        saveOnUnmount: false
    });


    const saveLogs = useCallback(() => {
        const videoProps = JSON.parse(localStorage.getItem('videoProps'));
        // Get detailed operating system information
        const osDetails = platform.os.toString();
        const browser = platform.name + ' ' + platform.version;
        addLog('Operating System: ' + osDetails);
        addLog('Browser: ' + browser);
        addLog('Selected Language: ' + selectedLng);

        videoCRUDServiceInstance
            .getVideosLogs(videoProps.id)
            .then((response) => {
                console.log(response);

                // Convert JSON object to string
                const jsonString = JSON.stringify(response, null, 2);
                addLog('Logs: ' + jsonString);

                copyLogsToClipboard();
            })
            .catch((e) => {
                console.log('ERROR', e);
            });
    }, []);

    const downloadSub = useCallback(
        (type) => {
            const videoProps = JSON.parse(localStorage.getItem('videoProps'));

            let text = '';
            //const name = `${videoProps?.videoUrl?.split('video/')[1].split('.mp4')[0]}.${type}`;
            let name = videoProps.videoName;
            let exportEnglish = false;
            if (selectedLng === 'English') {
                exportEnglish = true;
            }

            subtitle = window.localStorage.getItem('subtitle')
                ? JSON.parse(window.localStorage.getItem('subtitle'))
                : subtitle;

            let parsedSubtitle = [];

            subtitle.forEach((subtitle, index) => {
                const cue = {
                    identifier: '',
                    start: subtitle.start,
                    end: subtitle.end,
                    text: subtitle.text2,
                    Estart: subtitle.start,
                    Eend: subtitle.end,
                    Etext: subtitle.text,
                    note: subtitle.note,
                    bookmark: subtitle.bookmark,
                };
                parsedSubtitle.push(cue);
            });

            parsedSubtitle = parsedSubtitle.filter((transcript) => {
                return !(transcript.start === '00:00:00' && transcript.end === '00:00:00');
            });

            switch (type) {
                case 'vtt':
                    text = sub2vtt(parsedSubtitle, exportEnglish);
                    name = name + selectedLng + '.vtt';
                    break;
                case 'srt':
                    text = sub2srt(parsedSubtitle, exportEnglish);
                    name = name + selectedLng + '.srt';
                    break;
                case 'txt':
                    text = sub2srt(parsedSubtitle, exportEnglish);
                    name = name + selectedLng + '.txt';
                    break;
                default:
                    text = sub2srt(parsedSubtitle, exportEnglish);
                    name = name + selectedLng + '.srt';
                    break;
            }
            const url = URL.createObjectURL(new Blob([text]));
            download(url, name);
        },
        [subtitle, viewEng],
    );

    const mergeSubtitleWithEnglish = (stateUpdated) => {
        if (subtitle === undefined || subtitle.length === 0) {
            setLanguageSubTitle(stateUpdated);
        } else {
            // Capture the current state of the subtitles, it is either 1) English 2) previous right side
            // Read the subtitles for the selected language first
            const newLanguageScripts = stateUpdated.map((transcript) => ({
                ...transcript,
                start: transcript.start,
                end: transcript.end,
                text: transcript.text,
                text2: transcript.text,
                Estart: '',
                Eend: '',
                Etext: '',
                Etext2: '',
            }));

            // filter subtitle when Estart, Eend, Etext, Etext2 are empty
            subtitle = subtitle.filter((transcript) => {
                return (
                    transcript.Estart !== '' ||
                    transcript.Eend !== '' ||
                    transcript.Etext !== '' ||
                    transcript.Etext2 !== ''
                );
            });

            let mergeEnglishIntoNewLanguage = [];
            // Handle the special case when we are going from English to another language,
            // in that case subtitles will be empty, and we would need to fill them up.
            if (subtitle[0].Etext === undefined && subtitle[0].Etext2 === undefined) {
                newLanguageScripts.forEach((item1, index) => {
                    const item2 = subtitle[index] || {};
                    mergeEnglishIntoNewLanguage.push({
                        Estart: item2.start || '',
                        Eend: item2.end || '',
                        Etext: item2.text || '',
                        Etext2: item2.text2 || '',
                        start: item1.start,
                        end: item1.end,
                        text: item1.text,
                        text2: item1.text,
                    });
                });

                // Add to mergeEnglisIntoNewLanguage if the count of english subtitles is more than new language subtitles
                if (subtitle.length > newLanguageScripts.length) {
                    for (let i = newLanguageScripts.length; i < subtitle.length; i++) {
                        const item2 = subtitle[i];
                        mergeEnglishIntoNewLanguage.push({
                            Estart: item2.start || '',
                            Eend: item2.end || '',
                            Etext: item2.text || '',
                            Etext2: item2.text2 || '',
                            start: '00:00:00',
                            end: '00:00:00',
                            text: '',
                            text2: '',
                        });
                    }
                }
            } else {
                newLanguageScripts.forEach((item1, index) => {
                    const item2 = subtitle[index] || {};
                    mergeEnglishIntoNewLanguage.push({
                        Estart: item2.Estart || '',
                        Eend: item2.Eend || '',
                        Etext: item2.Etext || '',
                        Etext2: item2.Etext2 || '',
                        start: item1.start,
                        end: item1.end,
                        text: item1.text,
                        text2: item1.text,
                    });
                });

                // Add to mergeEnglisIntoNewLanguage if the count of english subtitles is more than new language subtitles
                if (subtitle.length > newLanguageScripts.length) {
                    for (let i = newLanguageScripts.length; i < subtitle.length; i++) {
                        const item2 = subtitle[i];
                        mergeEnglishIntoNewLanguage.push({
                            Estart: item2.Estart || '',
                            Eend: item2.Eend || '',
                            Etext: item2.Etext || '',
                            Etext2: item2.Etext2 || '',
                            start: '00:00:00',
                            end: '00:00:00',
                            text: '',
                            text2: '',
                        });
                    }
                }
            }

            setLanguageSubTitle(mergeEnglishIntoNewLanguage);
            console.log('mergedArray-if', mergeEnglishIntoNewLanguage);
        }
    };

    const onSubtitleChange = useCallback(
        (event) => {
            const file = event.target.files[0];
            if (file) {
                const ext = getExt(file.name);
                if (['ass', 'vtt', 'srt', 'json'].includes(ext)) {
                    file2vtt(file)
                        .then((res) => {
                            const stateUpdated = getSubNodesfromVtt(res);
                            mergeSubtitleWithEnglish(stateUpdated);
                            onAutoSave(file.name); // Now this will work correctly
                        })
                        .catch((err) => {
                            console.log(err.message);
                        });
                } else {
                    console.log('Unable to open this subtitle format');
                    // Add Swal to show the error that this extension is not supported
                    Swal.fire({
                        title: 'Error!',
                        text: 'The selected extension of file is not supported. Supported file formats (.srt, .vtt)',
                        icon: 'error',
                        confirmButtonText: 'Close',
                    });
                }
            }
        },
        [setSubtitle, clearSubs, formatSub, onAutoSave],  // Add onAutoSave to dependencies
    );

    const onInputClick = useCallback((event) => {
        event.target.value = '';
    }, []);

    const fetchData = async (selectedLanguage) => {
        let subtitleData = '';
        let videoPropsLng = JSON.parse(localStorage.getItem('videoProps'));
        let lnguageindex = videoPropsLng.videoLanguages
            .map((item, index) => (item.languageName === selectedLanguage ? index : -1))
            .filter((index) => index !== -1);
        try {
            console.log('Fetching VTT file', videoPropsLng.videoLanguages[lnguageindex[0]].vttFileUrl);

            const vttData = await fetchVTTFile(videoPropsLng.videoLanguages[lnguageindex[0]].vttFileUrl).catch(
                (error) => {
                    console.error('SubtitleEditor.js Error fetching VTT file:', error);
                },
            );
            if (vttData) {
                videoPropsLng.videoLanguages[lnguageindex[0]].subtitleString = vttData;
                subtitleData = vttData;
            }
        } catch (error) {
            console.log('SubtitleEditor.js  Error fetching VTT file:', error);
        }

        return subtitleData;
    };

    const handleChange = (event) => {
        let selectedLanguage = event.target.value;
        let videoPropsLng = JSON.parse(localStorage.getItem('videoProps'));
        let lnguageindex = videoPropsLng.videoLanguages
            .map((item, index) => (item.languageName === selectedLanguage ? index : -1))
            .filter((index) => index !== -1);

        if (videoPropsLng.videoLanguages[lnguageindex[0]].status === 'PROCESSING') {
            Swal.fire({
                title: 'Error!',
                text: 'The subtitles for this language are still processing. Come back to this video later',
                icon: 'error',
                confirmButtonText: 'Close',
            });
            return;
        }
        
        // Get current user and their access level for the selected language
        const user = JSON.parse(localStorage.getItem('authUser'));
        const accessLevel = user?.languageAccess?.[selectedLanguage] || 'READ';
        const hasWriteAccess = accessLevel === 'WRITE' || accessLevel === 'ADMIN';
        
        console.log(`User ${user?.email} has ${accessLevel} access to ${selectedLanguage} (Write access: ${hasWriteAccess})`);
        // Add a log entry for the language change
        addLog(
            `Changed language to ${selectedLanguage} - User access level: ${accessLevel}`
        );
        
        setSelectedLng(selectedLanguage);
        setLngIndex(lnguageindex[0]);

        localStorage.setItem('setSelectedLng', JSON.stringify(selectedLanguage));

        setBookmarked(videoPropsLng.videoLanguages[lnguageindex[0]].metadataCheckFlag);
        setSubtitleComment(videoPropsLng.videoLanguages[lnguageindex[0]].metadataComments);

        fetchData(selectedLanguage).then((subtitleData) => {
            const stateUpdated = getSubNodesfromVtt(subtitleData);
            mergeSubtitleWithEnglish(stateUpdated);
        });
        
    };

    const onLoad = useCallback(async () => {
        const pagebreadcrumbs = JSON.parse(localStorage.getItem('breadcrumbs'));
        setBreadcrumb(pagebreadcrumbs);

        const videoPropsLng = JSON.parse(localStorage.getItem('videoProps'));
        try {
            videoCRUDServiceInstance
                .getVideoDataOfId(videoPropsLng.id)
                .then((response) => {
                    const languagesList = response.data.videoLanguages.map((item) => item.languageName);
                    const uniqueLanguages = Array.from(new Set(languagesList));
                    setLanguages(uniqueLanguages);
                    localStorage.setItem('videoProps', JSON.stringify(response.data));
                })
                .catch((e) => {
                    console.log('ERROR', e);
                });
        } catch (e) {
            console.log('ERROR', e);
            const videoPropsLng = JSON.parse(localStorage.getItem('videoProps'));
            const languagesList = videoPropsLng.videoLanguages.map((item) => item.languageName);
            const uniqueLanguages = Array.from(new Set(languagesList));
            setLanguages(uniqueLanguages);
        }
    }, []);

    const onUnload = useCallback(() => {
        localStorage.removeItem('setSelectedLng');
    }, []);

    
    useEffect(() => {
        clearLogs();
    }, []);

    useEffect(() => {
        const pagebreadcrumbs = JSON.parse(localStorage.getItem('breadcrumbs'));
        setBreadcrumb(pagebreadcrumbs);
        window.addEventListener('load', onLoad);
        return () => {
            if (window !== null) {
                window.removeEventListener('load', onLoad);
            }
        };
    }, [onLoad]);

    useEffect(() => {
        window.addEventListener('focus', onLoad);
        window.addEventListener('beforeunload', onUnload);

        // Check initial access level for the selected language
        const user = JSON.parse(localStorage.getItem('authUser'));
        const accessLevel = user?.languageAccess?.[selectedLng] || 'READ';
        // Update UI based on access level - now checking for both WRITE and ADMIN
        const hasWriteAccess = accessLevel === 'WRITE' || accessLevel === 'ADMIN';
        
        // Only set up auto-save interval if user has WRITE or ADMIN access
        let interval;
        if (hasWriteAccess) {
            interval = setInterval(async () => {
                const result = await onAutoSave();
                // Optional logging based on result
                if (!result?.success) {
                    console.log("Auto-save failed:", result?.message || "Unknown error");
                }
            }, 30000);
        } else {
            //console.log(`Auto-save disabled for ${selectedLng} - User ${user?.email} has Read access`);
            addLog(`Auto-save disabled for ${selectedLng} - User has Read access`);
        }
        
        return () => {
            if (interval) {
                clearInterval(interval);
            }
            if (window !== null) {
                window.removeEventListener('focus', onLoad);
                window.removeEventListener('beforeunload', onUnload);
            }
        };
    }, [selectedLng, subtitleComment, bookmarked, onAutoSave]);  // Add onAutoSave to dependencies

    // Inside your component
    const handleBreadcrumbNavigate = ({ path }) => {
        console.log(`Navigating to breadcrumb path: ${path}`);
        
        // Update breadcrumbs in localStorage if needed
        const newBreadcrumbs = path.split('/').filter(segment => segment.length > 0);
        localStorage.setItem('breadcrumbs', JSON.stringify(newBreadcrumbs));
        
        // Navigate with state
        navigate('/', {
            state: {
                fromVideoEdit: true,
                folderPath: path,
                refreshNeeded: true,
            },
        });
    };

    // Add this effect to fetch sections when the language changes
    useEffect(() => {
        const fetchSections = async () => {
            if (!selectedLng) return;
            
            const videoProps = JSON.parse(localStorage.getItem('videoProps'));
            if (!videoProps || !videoProps.id) return;
            
            setLoadingSections(true);
            setSectionError(null);
            
            try {
                const response = await sectionManagementService.getSections(videoProps.id, selectedLng);
                setSections(response.data || []);
                
                // Clear selected section when changing languages
                setSelectedSection(null);
            } catch (err) {
                console.error('Error fetching sections:', err);
                setSections([]);
            } finally {
                setLoadingSections(false);
            }
        };
        
        fetchSections();
    }, [selectedLng]);

    // Add this useEffect hook after other state definitions in BugReportForm.js
    // Add this function after other utility functions in ToolBar.js

    const openBugReportWithCurrentVideo = () => {
    // Store the current video data in localStorage to be picked up by the form
    const videoProps = JSON.parse(localStorage.getItem('videoProps'));
    
    if (!videoProps) {
        // No video is currently loaded
        Swal.fire({
        title: 'No Video Selected',
        text: 'Please open a video before reporting an issue.',
        icon: 'warning',
        confirmButtonText: 'OK'
        });
        return;
    }
    
    // Get current language
    const currentLanguage = selectedLng || '';
    
    // Format path from breadcrumb
    const formattedPath = breadcrumb && breadcrumb.length > 0 
        ? `/${breadcrumb.join('/')}` 
        : '/';
    
    // Create a prefill object with all necessary information
    const prefillData = {
        category: 'editing_video',
        videoName: videoProps.videoName,
        videoId: videoProps.id,
        folderPath: formattedPath,
        languages: currentLanguage
    };
    
    // Store in localStorage for the bug report form to pick up
    localStorage.setItem('bugReportPrefill', JSON.stringify(prefillData));
    
    // Navigate to the bug report page
    window.open('/bug-report', '_blank');
    };
    

    // Add this function to handle section selection
    const handleSectionChange = async (event) => {
        const videoProps = JSON.parse(localStorage.getItem('videoProps'));
        if (!videoProps || !videoProps.id) return;
        
        const sectionId = event.target.value;
        
        // If "None" is selected, reset to the full subtitle
        if (sectionId === 'none') {
            setSelectedSection(null);
            
            // Reload the full VTT for this language
            let lnguageindex = videoProps.videoLanguages
                .map((item, index) => (item.languageName === selectedLng ? index : -1))
                .filter((index) => index !== -1);
                
            if (lnguageindex.length > 0) {
                try {
                    setLoading('Loading full subtitle...');
                    const vttData = await fetchVTTFile(videoProps.videoLanguages[lnguageindex[0]].vttFileUrl);
                    if (vttData) {
                        const stateUpdated = getSubNodesfromVtt(vttData);
                        setSubtitle(stateUpdated.map((item) => formatSub(item)), false);
                    }
                    setLoading('');
                } catch (error) {
                    console.error('Error loading full VTT:', error);
                    setLoading('');
                }
            }
            return;
        }
        
        // Find the selected section
        const section = sections.find(s => s.id === sectionId);
        if (!section) return;
        
        // Start editing this section
        try {
            setLoading('Loading section...');
            
            const response = await sectionManagementService.startSectionEditing(
                videoProps.id, 
                selectedLng, 
                sectionId
            );
            
            if (response.data && response.data.vttFileUrl) {
                // Load the section VTT content
                const vttData = await fetchVTTFile(response.data.vttFileUrl);
                if (vttData) {
                    const stateUpdated = getSubNodesfromVtt(vttData);
                    setSubtitle(stateUpdated.map((item) => formatSub(item)), false);
                    setSelectedSection(response.data);
                    
                    // Add a log entry that we're editing a section
                    addLog(`Editing section: ${response.data.name}`);
                }
            }
            setLoading('');
        } catch (err) {
            console.error('Error starting section edit:', err);
            setSectionError(`Failed to start editing section: ${err.message}`);
            
            // Show error to user
            Swal.fire({
                title: 'Error',
                text: `Failed to load section: ${err.message}`,
                icon: 'error'
            });
            setLoading('');
        }
    };

    // Add function to end section editing
    const endSectionEditing = async () => {
        if (!selectedSection) return;
        
        const videoProps = JSON.parse(localStorage.getItem('videoProps'));
        if (!videoProps || !videoProps.id) return;
        
        try {
            setLoading('Ending section editing...');
            
            // Save current work first
            const currentSubtitles = window.localStorage.getItem('subtitle')
                ? JSON.parse(window.localStorage.getItem('subtitle'))
                : subtitle;
                
            if (currentSubtitles && currentSubtitles.length > 0) {
                // Generate VTT content from subtitles
                let vttContent = "WEBVTT\n\n";
                
                for (const sub of currentSubtitles) {
                    if (sub.start === '00:00:00' && sub.end === '00:00:00') continue;
                    
                    vttContent += `${sub.start} --> ${sub.end}\n`;
                    vttContent += `${sub.text2}\n\n`;
                }
                
                // Save to the section
                await sectionManagementService.saveSection(
                    videoProps.id,
                    selectedLng,
                    selectedSection.id,
                    vttContent
                );
            }
            
            // End the editing session
            await sectionManagementService.endSectionEditing(
                videoProps.id,
                selectedLng,
                selectedSection.id
            );
            
            setSelectedSection(null);
            
            // Reload the full VTT
            let lnguageindex = videoProps.videoLanguages
                .map((item, index) => (item.languageName === selectedLng ? index : -1))
                .filter((index) => index !== -1);
                
            if (lnguageindex.length > 0) {
                const vttData = await fetchVTTFile(videoProps.videoLanguages[lnguageindex[0]].vttFileUrl);
                if (vttData) {
                    const stateUpdated = getSubNodesfromVtt(vttData);
                    setSubtitle(stateUpdated.map((item) => formatSub(item)), false);
                }
            }
            
            addLog('Section editing ended');
            setLoading('');
        } catch (err) {
            console.error('Error ending section edit:', err);
            Swal.fire({
                title: 'Error',
                text: `Failed to end section editing: ${err.message}`,
                icon: 'error'
            });
            setLoading('');
        }
    };

    // Create the section dropdown JSX
    const sectionDropdown = (
      <>
        {sections.length > 0 && (
          <FormControl 
            sx={{ 
              width: '15%',
              mr: 1,
              minHeight: '35px',
              alignSelf: 'center',
              '& .MuiInputBase-root': { 
                height: '35px',
                backgroundColor: selectedSection ? 'rgba(33, 150, 243, 0.2)' : 'rgba(255, 255, 255, 0.08)',
                borderRadius: '4px',
                color: '#fff',
                border: '1px solid rgba(255, 255, 255, 0.23)',
              },
              '& .MuiSelect-icon': {
                color: 'rgba(255, 255, 255, 0.7)'
              },
              '& .MuiInputLabel-root': {
                color: 'rgba(255, 255, 255, 0.7)'
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#90caf9'
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(255, 255, 255, 0.23)'
              },
              '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(255, 255, 255, 0.5)'
              },
              '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#90caf9'
              }
            }}
            size="small"
            variant="outlined"
          >
            <InputLabel id="section-select-label" sx={{ fontSize: '0.85rem' }}>
              {loadingSections ? 'Loading...' : 'Section'}
            </InputLabel>
            <Select
              labelId="section-select-label"
              id="sectionSelector"
              value={selectedSection ? selectedSection.id : 'none'}
              onChange={handleSectionChange}
              label={loadingSections ? 'Loading...' : 'Section'}
              disabled={loadingSections || readOnly}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                    backgroundColor: '#212121',
                    color: '#fff',
                    borderRadius: '4px',
                    border: '1px solid rgba(255, 255, 255, 0.12)'
                  },
                },
              }}
              renderValue={(selected) => {
                if (selected === 'none') {
                  return <em style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Full Subtitle</em>;
                }
                
                const section = sections.find(s => s.id === selected);
                if (!section) return <em style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Full Subtitle</em>;
                
                return (
                  <MuiBox sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <SplitscreenIcon fontSize="small" sx={{ color: '#90caf9' }} />
                    <span>{section.name}</span>
                  </MuiBox>
                );
              }}
            >
              <MenuItem value="none" sx={{ '&:hover': { backgroundColor: 'rgba(144, 202, 249, 0.08)' } }}>
                <em>Full Subtitle</em>
              </MenuItem>
              
              {sections.map(section => {
                const isLocked = section.locked && section.activeEditor !== JSON.parse(localStorage.getItem('authUser'))?.email;
                
                return (
                  <MenuItem 
                    key={section.id} 
                    value={section.id}
                    disabled={isLocked}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      '&:hover': { backgroundColor: 'rgba(144, 202, 249, 0.08)' },
                      '&.Mui-selected': { 
                        backgroundColor: 'rgba(144, 202, 249, 0.16)',
                        '&:hover': { backgroundColor: 'rgba(144, 202, 249, 0.24)' }
                      },
                      '&.Mui-disabled': { 
                        opacity: 0.5,
                        color: 'rgba(255, 255, 255, 0.5)'
                      }
                    }}
                  >
                    <span>{section.name}</span>
                    
                    {isLocked && (
                      <Chip 
                        label={`Locked by ${section.activeEditor}`}
                        size="small"
                        color="warning"
                        sx={{ 
                          ml: 1, 
                          fontSize: '0.7rem',
                          backgroundColor: 'rgba(237, 108, 2, 0.16)',
                          color: '#ffb74d',
                          borderColor: 'rgba(237, 108, 2, 0.5)'
                        }}
                      />
                    )}
                    
                    {section.locked && section.activeEditor === JSON.parse(localStorage.getItem('authUser'))?.email && (
                      <Chip 
                        label="You are editing"
                        size="small"
                        color="primary"
                        sx={{ 
                          ml: 1, 
                          fontSize: '0.7rem',
                          backgroundColor: 'rgba(33, 150, 243, 0.16)',
                          color: '#90caf9',
                          borderColor: 'rgba(33, 150, 243, 0.5)'
                        }}
                      />
                    )}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        )}
        
        {selectedSection && (
          <Tooltip title="End section editing and return to full subtitle">
            <Button
              onClick={endSectionEditing}
              variant="outlined"
              size="small"
              startIcon={<ExitToAppIcon />}
              sx={{
                height: '35px',
                minHeight: '35px',
                mr: 1,
                alignSelf: 'center',
                color: '#f44336',
                borderColor: 'rgba(244, 67, 54, 0.5)',
                backgroundColor: 'rgba(244, 67, 54, 0.08)',
                '&:hover': {
                  backgroundColor: 'rgba(244, 67, 54, 0.16)',
                  borderColor: '#f44336'
                }
              }}
            >
              Exit Section
            </Button>
          </Tooltip>
        )}
      </>
    );

    const handleShowReplace = () => {
        setShowReplace(prev => !prev);
    };

    const searchDebounceTimer = useRef(null);

    // Similarly, update the Hindi/Gujarati input handler
    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputText1(value);
        setLnagText1(value);
        
        // Clear any existing timer
        if (searchDebounceTimer.current) {
            clearTimeout(searchDebounceTimer.current);
        }
        
        // Set a new timer to delay the actual search execution
        searchDebounceTimer.current = setTimeout(() => {
            handleSearchTermChange(value);
        }, 500); // 500ms delay
    };

    const handleSearchTermChange = (term) => {
        setSearchTerm(term);
        
        // Clear any existing timer
        if (searchDebounceTimer.current) {
            clearTimeout(searchDebounceTimer.current);
        }
        
        // Set a new timer to delay the actual search execution
        searchDebounceTimer.current = setTimeout(() => {
            if (typeof onSearchTermChange === 'function') {
                onSearchTermChange(term);
            }
        }, 500); // 500ms delay before executing search
    };

    const handleReplaceTermChange = (term) => {
        setReplaceTerm(term);
        if (typeof onReplaceTermChange === 'function') {
            onReplaceTermChange(term);
        }
    };

    // Update effects to sync with parent props if needed
    useEffect(() => {
        if (parentSearchTerm !== undefined) {
            setSearchTerm(parentSearchTerm);
        }
    }, [parentSearchTerm]);

    useEffect(() => {
        if (parentReplaceTerm !== undefined) {
            setReplaceTerm(parentReplaceTerm);
        }
    }, [parentReplaceTerm]);

    // Add this useEffect to clean up the timer when component unmounts
    useEffect(() => {
        return () => {
            if (searchDebounceTimer.current) {
                clearTimeout(searchDebounceTimer.current);
            }
        };
    }, []);
    
    // Add this function inside your Header component, after the state variables
    const handleSearchClick = () => {
        // Toggle search drawer
        if (typeof handleShowSearch === 'function') {
            handleShowSearch();
            
            // If opening the search, focus the input after a slight delay to allow animation
            if (!showSearch) {
                setTimeout(() => {
                    const searchInput = document.querySelector('.searchboxs.open input');
                    if (searchInput) {
                        searchInput.focus();
                    }
                }, 300);
            }
        } else {
            // Fallback if the prop is not available
            setShowSearch(prev => !prev);
        }
    };

    // Rest of the component...

    // Return JSX with search functionality
    return (
        <Style className="tool">
            <div className="top">
                <div className="operate">
                <div className="breadcrumb" id="efitb">
                    <Box 
                        className="header-container"
                        ref={headerContainerRef}
                        sx={{ 
                            display: 'flex', 
                            width: '100%',
                            flexDirection: { xs: 'column', sm: 'row' }
                        }}
                    >
                        {/* Logo */}
                        <Tooltip title="Realise One's True Self and Serve Others Selflessly">

                            <Avatar 
                                src={Logo} 
                                alt="SRMD Logo" 
                                sx={{ 
                                    width: { xs: 32, sm: 40 },
                                    height: { xs: 32, sm: 40 }, 
                                    mr: { xs: 1, sm: 1.5 },
                                    fontSize: '0.4rem'
                                }}
                                size="small"
                            />
                        </Tooltip>
                            
                        {/* Right side column with title/subtitle and breadcrumbs */}
                        <Box 
                            className="right-section"
                            sx={{ 
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%'
                            }}
                        >
                            {/* Top row with title and subtitle */}
                            <Box 
                                className="top-row"
                                sx={{ 
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: { xs: 0.5, sm: 0.75 },
                                    flexWrap: 'wrap'
                                }}
                            >
                                {/* Only show tagline if containerWidth > 530 */}
                                {containerWidth > 530 && (
                                <Typography
                                    className="header-tagline"
                                    variant="subtitle1"
                                    sx={{ 
                                        color: 'rgba(255, 255, 255, 0.8)', 
                                        fontSize: { xs: '0.7rem', sm: '0.8rem' },
                                        fontStyle: 'italic',
                                        lineHeight: 1.2,
                                        display: { xs: 'none', sm: 'block' } // Hide on xs screens
                                    }}
                                >
                                    Realise One's True Self and Serve Others Selflessly
                                </Typography>
                                )}

                                <Typography
                                    className="user-info"
                                    variant="subtitle1"
                                    sx={{ 
                                        color: 'rgba(255, 255, 255, 0.8)', 
                                        fontSize: { xs: '0.7rem', sm: '0.8rem' },
                                        lineHeight: 1.2,
                                        marginLeft: { xs: 0, sm: '0.5rem' },
                                        marginRight: '0.5rem'
                                    }}
                                >
                                    {user.email ? formatUserName(user.email) : 'Guest'}
                                </Typography>

                                {selectedLng && (
                                    <Box 
                                        component="span"
                                        className="language-badge"
                                        sx={{ 
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            backgroundColor: (user?.languageAccess?.[selectedLng] === 'WRITE' || user?.languageAccess?.[selectedLng] === 'ADMIN') 
                                                ? 'rgba(76, 175, 80, 0.2)' 
                                                : 'rgba(255, 152, 0, 0.2)',
                                            color: (user?.languageAccess?.[selectedLng] === 'WRITE' || user?.languageAccess?.[selectedLng] === 'ADMIN')
                                                ? '#4caf50' 
                                                : '#ff9800',
                                            borderRadius: '4px',
                                            padding: { xs: '0px 4px', sm: '0px 8px' },
                                            marginLeft: '8px',
                                            fontSize: { xs: '0.65rem', sm: '0.7rem' },
                                            fontWeight: 'bold',
                                            border: '1px solid',
                                            borderColor: (user?.languageAccess?.[selectedLng] === 'WRITE' || user?.languageAccess?.[selectedLng] === 'ADMIN')
                                                ? 'rgba(76, 175, 80, 0.5)' 
                                                : 'rgba(255, 152, 0, 0.5)',
                                        }}
                                    >
                                        {(user?.languageAccess?.[selectedLng] === 'WRITE' || user?.languageAccess?.[selectedLng] === 'ADMIN') 
                                            ? 'EDIT' 
                                            : 'READ'}
                                    </Box>
                                )}
                            </Box>
                            
                            {/* Bottom row with breadcrumbs */}
                            <Box 
                                className="breadcrumb-row" 
                                sx={{ 
                                    width: '100%',
                                    overflow: 'hidden'
                                }}
                            >
                                <ModernBreadcrumbs 
                                    currentPath={currentPath}
                                    onNavigate={handleBreadcrumbNavigate}
                                    isDarkBackground={true}
                                    maxItems={containerWidth > 530 ? 3 : 2}
                                />
                            </Box>
                        </Box>
                    </Box>
                </div>
                    {/* Replace the full toolbar buttons section with this consistent styling */}
                    {/* Search Box */}
                        <div className={showSearch ? 'searchboxs open' : 'searchboxs'}>
                            <div className="searchboxlist">
                                <ul>
                                    <li className="search-input">
                                        {selectedLng === 'Hindi' || selectedLng === 'Gujarati' ? (
                                            <input
                                                type="text"
                                                placeholder="Find text in subtitles..."
                                                value={inputText1}
                                                onChange={handleInputChange}
                                                autoFocus
                                            />
                                        ) : (
                                            <input
                                                type="text"
                                                placeholder="Find text in subtitles..."
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    
                                                    // Clear any existing timer
                                                    if (searchDebounceTimer.current) {
                                                        clearTimeout(searchDebounceTimer.current);
                                                    }
                                                    
                                                    // Set a new timer to delay the actual search execution
                                                    searchDebounceTimer.current = setTimeout(() => {
                                                        handleSearchTermChange(e.target.value);
                                                    }, 500); // 500ms delay
                                                }}
                                                autoFocus
                                            />
                                        )}
                                    </li>
                                    <li>
                                        <span>
                                            {matchOffsets && matchOffsets.length > 0
                                                ? `Match ${currentMatchIndex + 1} of ${matchOffsets.length}`
                                                : 'No results'}
                                        </span>
                                        <button
                                            className="updown-navs"
                                            onClick={goToPreviousMatch}
                                            disabled={!matchOffsets || matchOffsets.length === 0}
                                        >
                                            <ArrowUpwardIcon />
                                        </button>
                                        <button
                                            className="updown-navs"
                                            onClick={goToNextMatch}
                                            disabled={!matchOffsets || matchOffsets.length === 0}
                                        >
                                            <ArrowDownwardIcon />
                                        </button>
                                        <button className="colsesearch" onClick={handleShowSearch}>
                                            <CloseIcon />
                                        </button>
                                    </li>
                                    <li>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={handleShowReplace}
                                            sx={{ 
                                                borderColor: 'rgba(255, 255, 255, 0.3)',
                                                color: '#fff',
                                                marginLeft: '8px',
                                                minWidth: '100px'
                                            }}
                                        >
                                            {showReplace ? 'Hide Replace' : 'Show Replace'}
                                        </Button>
                                    </li>
                                </ul>
                                {showReplace && (
                                    <ul>
                                        <li className="search-input">
                                            {selectedLng === 'Hindi' || selectedLng === 'Gujarati' ? (
                                                <input
                                                    type="text"
                                                    placeholder="Replace with..."
                                                    value={inputText2}
                                                    onChange={(e) => {
                                                        setInputText2(e.target.value);
                                                        handleReplaceTermChange(e.target.value);
                                                    }}
                                                />
                                            ) : (
                                                <input
                                                    type="text"
                                                    placeholder="Replace with..."
                                                    value={replaceTerm}
                                                    onChange={(e) => {
                                                        setReplaceTerm(e.target.value);
                                                        handleReplaceTermChange(e.target.value);
                                                    }}
                                                />
                                            )}
                                        </li>
                                        <li>
                                            <div className="buttons">
                                                <button onClick={handleReplace}>Replace</button>
                                                <button onClick={handleReplaceAll}>Replace All</button>
                                            </div>
                                        </li>
                                    </ul>
                                )}
                            </div>
                        </div>
                    <div className="operate">
                        <div className="right-buttons">
                            <Box className="operate" sx={{ display: 'flex', width: '100%' }}>
                                <Grid 
                                    container 
                                    justifyContent="flex-end" 
                                    spacing={1} 
                                    alignItems="center"
                                    sx={{ flexWrap: 'nowrap' }}
                                >
                                    {/* Search button */}
                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        <Tooltip title="Search">
                                            <Button
                                                color="inherit"
                                                onClick={handleSearchClick}
                                                sx={{
                                                    minWidth: 'auto',
                                                    padding: '6px',
                                                    height: '35px'
                                                }}
                                            >
                                                <SearchIcon fontSize="small" />
                                            </Button>
                                        </Tooltip>
                                    </Grid>

                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        {/* Language dropdown */}
                                        <FormControl sx={{ 
                                            width: '120px',
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: '#252526',
                                                color: '#cccccc',
                                                height: '35px'
                                            }
                                        }} size="small">
                                            <Select
                                                id="languagesToEdit"
                                                onChange={handleChange}
                                                value={selectedLng}
                                            >
                                                {getLanguagesForEditView()?.map((item, index) => (
                                                    <MenuItem key={index} value={item} selected={item === 'English'}>
                                                        {item}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    
                                    <Grid item sx={{ alignSelf: 'center' }}>
                                    {sectionDropdown}
                                    </Grid>

                                    {/* Export Type dropdown - show conditionally */}
                                    <Grid item sx={{ alignSelf: 'center', display: { xs: 'none', sm: 'block' } }}>
                                        <Tooltip title="Export Subtitles">
                                            <FormControl sx={{ 
                                                width: '120px',
                                                '& .MuiOutlinedInput-root': {
                                                    backgroundColor: '#252526',
                                                    color: '#cccccc',
                                                    height: '35px'
                                                }
                                            }} size="small">
                                                <Select
                                                    id="exportTypeDropdown"
                                                    value={exportValue}
                                                    onChange={(e) => {
                                                        setExportValue(e.target.value);
                                                    }}
                                                >
                                                    <MenuItem value="SRT">Export SRT</MenuItem>
                                                    <MenuItem value="VTT">Export VTT</MenuItem>
                                                    <MenuItem value="ASS">Export ASS</MenuItem>
                                                    <MenuItem value="TXT">Export TXT</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Tooltip>
                                    </Grid>
                                    
                                    {/* Export button - responsive text */}
                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        <Tooltip title="Export">
                                            <Button 
                                                id="exportButton"
                                                variant="vsCodeBlue"
                                                sx={{ 
                                                    height: '35px',
                                                    minWidth: { xs: '40px', lg: '100px' },
                                                }}
                                                onClick={(e) => {
                                                    if (exportValue === 'SRT') {
                                                        downloadSub('srt');
                                                    } else if (exportValue === 'VTT') {
                                                        downloadSub('vtt');
                                                    } else if (exportValue === 'ASS') {
                                                        downloadSub('ass');
                                                    } else if (exportValue === 'TXT') {
                                                        downloadSub('txt');
                                                    }
                                                }}
                                            >
                                                <FileDownloadIcon fontSize="small" />
                                                <Box component="span" sx={{ display: { xs: 'none', lg: 'inline' }, ml: 0.5 }}>
                                                    Export
                                                </Box>
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                    
                                    {/* Import button - responsive text */}
                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        <Tooltip title="Import SRT">
                                            <Button
                                                id="importButton"
                                                variant="vsCodeBlue"
                                                component="label"
                                                sx={{ 
                                                    height: '35px',
                                                    minWidth: { xs: '40px', lg: '110px' },
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                <FileUploadIcon fontSize="small" />
                                                <Box component="span" sx={{ display: { xs: 'none', lg: 'inline' }, ml: 0.5 }}>
                                                    Import SRT
                                                </Box>
                                                <input className="file" type="file" hidden onChange={onSubtitleChange} onClick={onInputClick} />
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                    
                                    
                                    {/* Undo button - responsive text */}
                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        <Tooltip title="Undo">
                                            <Button
                                                id="undoButton"
                                                variant="vsCodeBlue"
                                                sx={{ 
                                                    height: '35px',
                                                    minWidth: { xs: '40px', lg: '100px' },
                                                }}
                                                onClick={undoSubs}
                                            >
                                                <ReplayIcon fontSize="small" />
                                                <Box component="span" sx={{ display: { xs: 'none', lg: 'inline' }, ml: 0.5 }}>
                                                    Undo
                                                </Box>
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                    
                                    {/* Save button - responsive text */}
                                    <Grid item sx={{ alignSelf: 'center', display: 'flex', alignItems: 'center' }}>
                                        {(() => {
                                            const user = JSON.parse(localStorage.getItem('authUser'));
                                            const accessLevel = user?.languageAccess?.[selectedLng] || 'READ';
                                            const hasWriteAccess = accessLevel === 'WRITE' || accessLevel === 'ADMIN';
                                            
                                            return (
                                                <Tooltip title={
                                                    !hasWriteAccess
                                                        ? "You are in read-only mode"
                                                        : lastSaveTime 
                                                            ? isSaving 
                                                                ? "Saving..." 
                                                                : `Last saved: ${new Date(lastSaveTime).toLocaleTimeString()}`
                                                            : "Save changes"
                                                }>
                                                    <Button
                                                        id="saveButton"
                                                        variant="vsCodeBlue"
                                                        sx={{ 
                                                            height: '35px',
                                                            minWidth: { xs: '40px', lg: '100px' },
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '6px'
                                                        }}
                                                        onClick={(e) => {
                                                            // Existing onClick handler with hasWriteAccess check already there
                                                            if (!hasWriteAccess) {
                                                                Swal.fire({
                                                                    title: 'Read-Only Mode',
                                                                    text: 'You cannot save changes while in read-only mode.',
                                                                    icon: 'warning',
                                                                    confirmButtonText: 'OK'
                                                                });
                                                                return;
                                                            }
                                                            
                                                            Swal.fire({
                                                                title: 'Do you want to save changes?',
                                                                showDenyButton: true,
                                                                showCancelButton: true,
                                                                confirmButtonText: 'Save',
                                                                denyButtonText: `Don't save`,
                                                            }).then(async (result) => {
                                                                const videoProps = JSON.parse(localStorage.getItem('videoProps'));
                                                                
                                                                if (result.isConfirmed) {
                                                                    setLoading('Loading...');
                                                                    
                                                                    // Filter subtitles where start, end, text are empty
                                                                    const filteredSubtitle = subtitle.filter((transcript) => {
                                                                        return (
                                                                            transcript.start !== '00:00:00' ||
                                                                            transcript.end !== '00:00:00' ||
                                                                            transcript.text !== '' ||
                                                                            transcript.text2 !== ''
                                                                        );
                                                                    });
                                                                    
                                                                    // Use the new service method
                                                                    const saveResult = await videoCRUDServiceInstance.saveSubtitleContent(
                                                                        filteredSubtitle, 
                                                                        selectedLng, 
                                                                        bookmarked, 
                                                                        subtitleComment,
                                                                        addLog,
                                                                        true // Show feedback messages
                                                                    );
                                                                    
                                                                    setLoading(''); // Clear loading state
                                                                } else if (result.isDenied) {
                                                                    addLog(
                                                                        'User Denied Saving of Video = ' +
                                                                        videoProps.id +
                                                                        ' VideoName = ' +
                                                                        videoProps.videoName +
                                                                        ' Language = ' +
                                                                        selectedLng
                                                                    );
                                                                    Swal.fire('Changes are not saved', '', 'info');
                                                                }
                                                            });
                                                        }}
                                                    >
                                                        {isSaving ? (
                                                            <>
                                                                <CircularProgress size={16} color="inherit" sx={{ mr: 0.5 }} />
                                                                <Box component="span" sx={{ display: { xs: 'none', lg: 'inline' }, ml: 0.5 }}>
                                                                    Saving
                                                                </Box>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {!hasWriteAccess ? (
                                                                    <LockIcon fontSize="small" sx={{ color: '#ff5252' }} />
                                                                ) : (
                                                                    <SaveIcon fontSize="small" />
                                                                )}
                                                                <Box component="span" sx={{ display: { xs: 'none', lg: 'inline' }, ml: 0.5 }}>
                                                                    Save
                                                                </Box>
                                                                {!hasWriteAccess ? (
                                                                    <Box 
                                                                        sx={{ 
                                                                            ml: 0.5, 
                                                                            width: '6px', 
                                                                            height: '6px', 
                                                                            borderRadius: '50%', 
                                                                            backgroundColor: '#ff5252', // Red for read-only
                                                                        }} 
                                                                    />
                                                                ) : lastSaveTime && (
                                                                    <Box 
                                                                        sx={{ 
                                                                            ml: 0.5, 
                                                                            width: '6px', 
                                                                            height: '6px', 
                                                                            borderRadius: '50%', 
                                                                            backgroundColor: 'green', // Green for writable with last save
                                                                        }} 
                                                                    />
                                                                )}
                                                            </>
                                                        )}
                                                    </Button>
                                                </Tooltip>
                                            );
                                        })()}
                                    </Grid>

                                    {/* Bug report button - responsive text */}
                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        <Tooltip title="Report a bug with this video">
                                            <Button
                                                id="reportBugButton"
                                                variant="vsCodeBlue"
                                                sx={{ 
                                                    height: '35px',
                                                    minWidth: { xs: '40px', lg: '110px' },
                                                    whiteSpace: 'nowrap',
                                                }}
                                                onClick={openBugReportWithCurrentVideo}
                                            >
                                                <BugReportIcon fontSize="small" />
                                                <Box component="span" sx={{ display: { xs: 'none', lg: 'inline' }, ml: 0.5 }}>
                                                    Report Bug
                                                </Box>
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </Box>
                        </div>
                    </div>
                </div>
            </div>

            
        </Style>
    );
}
